<template>
  <SubHeader title="Rapports" :breads="[{ name: 'Rapports' }]" :action="{}" />

  <div
    v-if="isLoading"
    class=""
    style="
      min-height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
  >
    <div class="spinner-grow" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div
    v-else-if="!isSuccess"
    class=""
    style="
      min-height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
  >
    Un probleme est subvenu
  </div>

  <div v-else-if="item.paragraphe_one" class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-6">
              <div class="d-flex justify-content-between align-items-center">
                <!-- <i-range v-model="date" :max-date="new Date()" model-type="yyyy-MM-dd"
                                    multi-calendars range :enable-time-picker="false" /> -->
                <!-- <i-range v-model="date" :max-date="new Date()" model-type="yyyy-MM-dd"
                                    :enable-time-picker="false" /> -->
                <b>Du</b>
                <input
                  type="date"
                  name=""
                  :max="new Date().toISOString().split('T')[0]"
                  v-model="params.start_date"
                  class="form-control mx-2"
                  id=""
                />
                <b>au</b>
                <input
                  type="date"
                  name=""
                  :max="new Date().toISOString().split('T')[0]"
                  v-model="params.end_date"
                  class="form-control mx-2"
                  id=""
                />
                <div class="row mx-2">
                  <a
                    class="btn btn-primary col-sm-12 fs-12"
                    @click="
                      () => {
                        filterDataSubmit();
                      }
                    "
                    >Filtrer</a
                  >
                </div>
              </div>
            </div>

            <div
              class="col-6 text-end d-flex align-items-end justify-content-end"
            >
              <!-- @if ($profile != 'Agent Support') -->
              <div class="row align-items-center">
                <div class="col-auto">
                  <div class="dropdown me-2">
                    <button
                      type="button"
                      @click="getFile"
                      v-if="false"
                      class="btn btn-white btn-sm"
                    >
                      <i class="bi-download me-2"></i> Exporter
                    </button>
                    <button
                      type="button"
                      @click="generateWordDocPrepare"
                      class="btn btn-white btn-sm"
                    >
                      <i class="bi-download me-2"></i> Exporter
                    </button>
                  </div>
                </div>
              </div>
              <!-- @endif -->
            </div>
          </div>
        </div>
        <div
          class="card-body datatable-custom position-relative table-responsive"
        >
          <div class="row">
            <div class="col">
              <div class="container mt-5">
                <h3 class="mb-3">
                  1. Point des plaintes / dénonciations reçue du
                  <span>{{ item.paragraphe_one.periode }} </span>
                </h3>
                <p>
                  Au titre du
                  <span>{{ item.paragraphe_one.titre_trimestre }} </span> la
                  Cellule d'analyse et de traitement des plaintes et
                  dénonciations a enrégistré
                  <span>{{ item.array_one.total }}</span> plaintes /
                  dénonciations. Leur répartition selon la source se présente
                  comme suit :
                </p>
                <h5 class="mt-5">
                  <b>Tableau 1:</b> Plaintes/dénonciations par canal de
                  réception
                </h5>
                <table class="mb-2 table table-bordered table-hover text-white">
                  <thead class="table-dark">
                    <tr>
                      <th class="text-white text-center">
                        Plaintes/dénonciations
                      </th>
                      <th class="text-white text-center">
                        Plateforme (Site web)
                      </th>
                      <th class="text-white text-center">Centre d'appel</th>
                      <th class="text-white text-center">Dépôts physiques</th>
                      <th class="text-white text-center">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">{{ item.array_one.date }}</td>
                      <td class="text-center">{{ item.array_one.web }}</td>
                      <td class="text-center">
                        {{ item.array_one.call_center }}
                      </td>
                      <td class="text-center">{{ item.array_one.physique }}</td>
                      <td class="text-center">{{ item.array_one.total }}</td>
                    </tr>
                  </tbody>
                </table>

                <p>{{ item.sub_paragraphe_one }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="container mt-5">
                <h3 class="mb-3">2. Traitement des Plaintes/dénonciations</h3>
                <p>
                  Toutes les plaintes/dénonciations reçues ont été prises en
                  charge et systématiquement affectées ainsi qu'il suit:
                </p>
                <h5 class="mt-5">
                  <b>Tableau 2.</b> Prise en charge des Plaintes/dénonciations
                </h5>
                <table class="mb-1 table table-bordered table-hover text-white">
                  <thead class="table-dark">
                    <tr>
                      <th class="text-white text-center">
                        Classées sans suite
                      </th>
                      <th class="text-white text-center">
                        Transférées aux structures
                      </th>
                      <th class="text-white text-center">Traitées à la CPD</th>
                      <th class="text-white text-center">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">
                        {{ item.array_two.sans_suite }}
                      </td>
                      <td class="text-center">
                        {{ item.array_two.structure }}
                      </td>
                      <td class="text-center">{{ item.array_two.interne }}</td>
                      <td class="text-center">{{ item.array_two.total }}</td>
                    </tr>
                  </tbody>
                </table>
                <div>
                  Comme souvent rapporté, la majorité des plaintes/dénonciations
                  soumises sur les différents canaux de réception ne relèvent
                  pas de la compétence de la Cellule. Pour ce trimestre on
                  retrouve principalement:
                  <ul style="list-style: none; padding-left: 5">
                    <li>
                      -
                      <span
                        >des arnaques de citoyens par voie électronique;</span
                      >
                    </li>
                    <li>
                      -
                      <span
                        >de nombreuses situations conflictuelles entre Police et
                        usagers de la route;</span
                      >
                    </li>
                    <li>- <span>des litiges domaniaux.</span></li>
                  </ul>
                  En ce qui concerne particulièrement les conflits
                  Police/usagers de la route qui font l'objet de plaintes
                  récurrentes, un échange verbal a eu lieu entre le
                  coordonnateur CPD et le Directeur Général de la Police
                  Républicaine qui dit être bien informé de la situation.
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="container mt-5">
                <h3 class="mb-3">
                  3. Plaintes/dénonciations traitées à la CDP
                </h3>
                <p>
                  <span>{{ item.paragraphe_three }}</span>
                </p>
                <h5 class="mt-5">
                  Tableau 3: Etat des Plaintes/dénonciations traitées
                </h5>
                <table class="mb-1 table table-bordered table-hover text-white">
                  <thead class="table-dark">
                    <tr>
                      <th class="text-white text-center">#</th>
                      <th class="text-white text-center">
                        Structure concernée
                      </th>
                      <th class="text-white text-center">
                        Description sommaire
                      </th>
                      <th class="text-white text-center">Commentaires</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(plainte, i) in item.array_three" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-center">{{ plainte.structure }}</td>
                      <td class="text-center">{{ plainte.description }}</td>
                      <td class="text-center">-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="container mt-5">
                <h3 class="mb-3">4. Plaintes/dénonciations transférées</h3>
                <p>{{ item.paragraphe_four }}</p>
                <h5 class="mt-5">
                  Tableau 4: Etat des Plaintes/dénonciations transférées au
                  cours du trimestre
                </h5>
                <table class="mb-1 table table-bordered table-hover text-white">
                  <thead class="table-dark">
                    <tr>
                      <th class="text-white text-center">#</th>
                      <th class="text-white text-center">
                        Description sommaire
                      </th>
                      <th class="text-white text-center">
                        Structure / date de transfert
                      </th>
                      <th class="text-white text-center">Observations</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(plainte, i) in item.array_four" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-center">{{ plainte.description }}</td>
                      <td class="text-center">{{ plainte.structure }}</td>
                      <td class="text-center">{{ plainte.observations }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SubHeader from "@/layouts/admin/SubHeader.vue";
import { generateWordDoc } from "@/utils";
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "DossierStatsRapport",

  data() {
    return {};
  },
  components: {
    SubHeader,
  },
  computed: {
    ...mapFields("rapport/info", {
      isLoading: "isLoading",
      isSuccess: "isSuccess",
      showMessage: "showMessage",
      message: "message",
      item: "item",
      params: "params",
    }),
  },
  methods: {
    ...mapActions({
      getRapport: "rapport/info/getInfo",
      getFile: "rapport/info/getFile",
      reset: "rapport/info/resetData",
    }),
    async generateWordDocPrepare() {
      await generateWordDoc(this.item);
    },
    filterDataSubmit() {
      if (!this.params.end_date || !this.params.start_date) {
        return;
      } else {
        this.getRapport();
      }
    },
    initDate() {
      var start_date = new Date();
      var end_date = new Date();
      start_date.setMonth(start_date.getMonth() - 3);
      this.params.start_date = start_date.toISOString().split("T")[0];
      this.params.end_date = end_date.toISOString().split("T")[0];
      // this.date = [start_date,end_date];
    },
  },
  mounted() {
    this.initDate();
    this.getRapport();
  },
  unmounted() {
    this.reset();
  },
};
</script>
